
export default function hydrator(parameters, data, chart) {


}
